import React, { useEffect, useState } from "react";
import { Container } from "reactstrap";
import { toast } from "react-toastify";
import { FetchUser } from "../../apis/User";
import { useParams } from "react-router";
import { useNavigate } from "react-router-dom";

const ProfileView = () => {
  const [user, setUser] = useState();
  const params = useParams();
  const navigate = useNavigate();

  const fetchUserDetails = async () => {
    const userId = params.userId;
    const result = await FetchUser(userId);
    setUser(result.user);
  };

  useEffect(() => {
    try {
      fetchUserDetails();
    } catch (err) {
      toast.error("Error loading user details");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const obscureEmail = (email) => {
    const [name, domain] = email.split("@");
    return `${name[0]}${new Array(name.length - 1).join("*")}${
      name[name.length - 1]
    }@${domain[0]}${new Array(domain.length - 1).join("*")}${
      domain[domain.length - 1]
    }`;
  };

  return (
    <React.Fragment>
      <div className="page-content">
      <Container fluid>
        <div className="p-6 flex flex-col gap-6">
          <h1 className="text-2xl">View verified profile</h1>
          <div className="w-full flex justify-end">
            <button
              onClick={() => navigate(-1)}
              className="w-fit text-lg px-4 bg-white font-bold text-primaryColor py-2 rounded border-[1px] border-primaryColor"
            >
              Go Back
            </button>
          </div>
          {user && (
            <div className="flex flex-col rounded-md border border-black dark:border-white">
              <div className="flex flex-col lg:flex-row gap-2 items-center p-3 border-b border-black">
                <div className="lg:w-[40%] text-lg font-bold">
                  Profile photo
                </div>
                <div className="lg:w-[60%]">
                  <div
                    className="size-24 rounded-full "
                    style={{
                      backgroundImage: `url(/user.png)`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                    }}
                  ></div>
                </div>
              </div>
              <div className="flex flex-col lg:flex-row gap-2 items-center p-3 border-b border-black">
                <div className="lg:w-[40%] text-lg font-bold">First name</div>
                <div className="lg:w-[60%] text-lg">{user.firstName}</div>
              </div>
              <div className="flex flex-col lg:flex-row gap-2 items-center p-3 border-b border-black">
                <div className="lg:w-[40%] text-lg font-bold">Last name</div>
                <div className="lg:w-[60%] text-lg">{user.lastName}</div>
              </div>
              <div className="flex flex-col lg:flex-row gap-2 items-center p-3 border-b border-black">
                <div className="lg:w-[40%] text-lg font-bold">Email</div>
                <div className="lg:w-[60%] text-lg">
                  {obscureEmail(user.email)}
                </div>
              </div>
              <div className="flex flex-col lg:flex-row gap-2 items-center p-3">
                <div className="lg:w-[40%] text-lg font-bold">Verification</div>
                <div className="lg:w-[60%] text-lg">
                  {(user.emailConfirmed && "Email verified") || "Not verified"}
                </div>
              </div>

              <div className="flex flex-col lg:flex-row gap-2 items-center p-3">
                <div className="lg:w-[40%] text-lg font-bold">User Type</div>
                <div className="lg:w-[60%] text-lg">{user.type}</div>
              </div>
            </div>
          )}

          <h1 className="text-2xl">Banking Account details</h1>

          {user && (
            <div className="flex flex-col rounded-md border border-black dark:border-white">
              <div className="flex flex-col lg:flex-row gap-2 items-center p-3 border-b border-black">
                <div className="lg:w-[40%] text-lg font-bold">Bank name</div>
              </div>
              <div className="flex flex-col lg:flex-row gap-2 items-center p-3 border-b border-black">
                <div className="lg:w-[40%] text-lg font-bold">
                  Account title
                </div>
                <div className="lg:w-[60%] text-lg"></div>
              </div>
              <div className="flex flex-col lg:flex-row gap-2 items-center p-3 border-b border-black">
                <div className="lg:w-[40%] text-lg font-bold">
                  Account number
                </div>
                <div className="lg:w-[60%] text-lg"></div>
              </div>
              <div className="flex flex-col lg:flex-row gap-2 items-center p-3 border-b border-black">
                <div className="lg:w-[40%] text-lg font-bold">Account IBAN</div>
                <div className="lg:w-[60%] text-lg"></div>
              </div>
              <div className="flex flex-col lg:flex-row gap-2 items-center p-3">
                <div className="lg:w-[40%] text-lg font-bold">Phone number</div>
                <div className="lg:w-[60%] text-lg"></div>
              </div>
            </div>
          )}
        </div>
      </Container>
      </div>
    </React.Fragment>
  );
};

export default ProfileView;
